/**
 * 安定した一意 ID を生成する（生成担当 共通）。
 *
 * アドインの実行環境（Edge WebView2 / 近代ブラウザ）の `crypto.randomUUID` を用いる。
 * オフライン・同期で完結し、衝突しない ID を得る。
 */
export function createId(): string {
    return globalThis.crypto.randomUUID();
}
